import { jsx } from "react/jsx-runtime";
import alpha from "color-alpha";
import { CheckedIcon } from "./components/CheckedIcon/CheckedIcon.js";
import { IndeterminateIcon } from "./components/IndeterminateIcon/IndeterminateIcon.js";
import "@mui/material/SvgIcon/index.js";
const MuiCheckbox = {
  defaultProps: {
    checkedIcon: /* @__PURE__ */ jsx(CheckedIcon, {}),
    indeterminateIcon: /* @__PURE__ */ jsx(IndeterminateIcon, {})
  },
  styleOverrides: {
    root: ({ theme }) => ({
      padding: "8px",
      margin: "-8px",
      color: theme.palette.grey[800],
      "&:hover": {
        color: theme.palette.primary[900],
        backgroundColor: alpha(theme.palette.primary[800], 0.08)
      },
      "&:focus": {
        color: theme.palette.primary[900],
        backgroundColor: alpha(theme.palette.primary[800], 0.12)
      },
      "&.Mui-checked": {
        color: theme.palette.primary[800],
        "&:hover": {
          color: theme.palette.primary[800]
        },
        "&:focus": {
          color: theme.palette.primary[800]
        }
      },
      "&.MuiCheckbox-indeterminate": {
        color: theme.palette.primary[800],
        "&:hover": {
          color: theme.palette.primary[800]
        },
        "&:focus": {
          color: theme.palette.primary[800]
        }
      },
      "&.Mui-disabled": {
        color: alpha(theme.palette.grey[800], 0.38)
      }
    })
  }
};
export {
  MuiCheckbox
};
